'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var variables = require('../variables-1eb6495a.js');

// This module is publicly exposed
const COLORS = {
    ...variables.GREYSCALE,
    MISC_FOCUS_BORDER: variables.COLORS.MISC_FOCUS_BORDER,
};

exports.COLORS = COLORS;
